<template>
  <div style="margin-top: 0.5rem; padding: 0">
    <quill-editor
      v-if="!loading"
      ref="myQuillEditorWithMentions"
      @change="onEditorChange($event)"
      style="width: 100%; margin-bottom: 1rem; padding: 0"
      :content="content"
      :id="editorId"
      :options="editorOptions"
    >
    </quill-editor>
  </div>
</template>
<script>
import "quill-mention";
export default {
  name: "HtmlEditorWithMentions",
  props: ["startContent", "editorId", "withoutAllReplacements"],
  data() {
    return {
      content: "",
      loading: true,
    };
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch("fetchAllAdmins");
    if (this.startContent.length > 0) this.content = this.startContent;
    this.loading = false;
  },

  watch: {
    startContent() {
      if (this.startContent.length > 0) this.content = this.startContent;
    },
  },

  methods: {
    getAllAdminsForMentions() {
      return this.allAdmins.map((a) => {
        return {
          ...a,
          id: a.id,
          value: a.phone,
        };
      });
    },

    onEditorChange({ html }) {
      if (html !== null && html !== undefined) {
        let htmlWithReplacedCharacters = html;
        if (html) {
          htmlWithReplacedCharacters = html

            .replaceAll(`class="ql-align-center"`, `style="text-align: center"`)
            .replaceAll(
              `class="ql-align-justify"`,
              `style="text-align: justify"`
            )
            .replaceAll(`class="ql-align-right"`, `style="text-align: right"`);

          if (!this.withoutAllReplacements) {
            htmlWithReplacedCharacters = html
              .replaceAll(
                "&lt;partners&gt;Lista partnerów&lt;/partners&gt;",
                "<partners>Lista partnerów</partners>"
              )

              .replaceAll("&lt;hide&gt;", "<hide>")
              .replaceAll("<p>", "")
              .replaceAll("</p>", "")
              .replaceAll(
                `</li><li>NESTED-LIST</li>`,
                `<ol style="list-style-type: lower-alpha !important; list-style-position: inside;">`
              )
              .replaceAll(`<li>END-NESTED-LIST</li>`, `</ol></li>`)
              .replaceAll(`<span>`, ``)
              .replaceAll(`</span>`, ``);
          }
        }

        this.$emit("contentchanged", htmlWithReplacedCharacters);
      }
    },
  },

  computed: {
    editorOptions() {
      const admins = this.getAllAdminsForMentions();
      const editorOptions = {
        modules: {
          mention: {
            defaultMenuOrientation: "top",
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@", "#"],
            source: async function (searchTerm, renderList) {
              let values = admins;

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value
                      .toLowerCase()
                      .indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            },
          },
        },
      };
      return editorOptions;
    },

    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill;
      } else {
        return null;
      }
    },
    allAdmins() {
      const admins = this.$store.getters.getAllAdmins;
      if (admins) {
        return admins.filter((admin) => admin.has_dod_access);
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped>
.a {
  text-align: right;
}
</style>
